import { useLanguageContext } from "../../../context/LanguageContext";
import useCustomEffect from "../../../hooks/useCustomEffect";
import useEvaApi, { EvaApiCall } from "../../../hooks/useEvaApi";
import ReleaseNotesPageView from "./ReleaseNotesPageView";
import { useState } from "react";

function ReleaseNotesPage() {
  const { language } = useLanguageContext();
  const callEvaApi = useEvaApi();
  const [releaseNotes, setReleaseNotes] = useState([]);

  useCustomEffect(() => {
    fetchReleaseNotes();
  }, []);

  /*
   * Fetches release notes file from the API
   */
  async function fetchReleaseNotes() {
    await callEvaApi(
      new EvaApiCall("release_notes")
        .setLoadingGroup("release_notes_page_fetch")
        .setOnSuccess((response) => {
          setReleaseNotes(response.data.data);
        })
    );
  }

  /**
   * This method will get the release note change based on the current language
   * @param {object} change
   * @returns {string|null}
   */
  function getReleaseNoteChange(change) {
    const changeKeys = Object.keys(change);
    let changeKey = changeKeys.find((key) => key.startsWith(language.code));
    changeKey = changeKey ?? changeKeys.find((key) => key.startsWith("en"));
    return changeKey ? change[changeKey] : null;
  }

  return (
    <ReleaseNotesPageView
      releaseNotes={releaseNotes}
      getReleaseNoteChange={getReleaseNoteChange}
    />
  );
}

export default ReleaseNotesPage;
